module.exports = __webpack_public_path__ + "assets/img/addTask_btn1.bdda8c4b.png";